import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useGroupPosition() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/groupposition/")
    .then((res: SuccessFetch<{
      payload: {
        group_position_id: number
        group_position_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.group_position_name, value: item.group_position_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)
    
    api.get("/groupposition/")
    .then((res: SuccessFetch<{
      payload: {
        group_position_id: number
        group_position_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.group_position_name, value: item.group_position_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}